import { createContext } from 'react';

interface AutosaveContextScopeData {
  displayLoader: boolean;
  handleScopeReset: () => void;
  inProgress: boolean;
  loaderHasFailed: string | false;
  loaderHasSucceeded: boolean;
}

type AutosaveContextCallback = () => void;

export type AutosaveContextValue = [AutosaveContextCallback, AutosaveContextScopeData];

export const AutosaveContext = createContext<AutosaveContextValue>([null, null]);
